import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Eye, ChevronLeft, ChevronRight, Copy } from "lucide-react";
import {
  useGetNotificationActivityApiCallQuery,
  useGetRefferalsApiCallQuery,
  useGetRefferalUsersApiCallQuery,
  useGetTokenPriceConversionApiCallQuery,
} from "@/services/api/auth/auth.api";
import {
  useGetTransactionsApiCallQuery,
  useGetTransactionsHistoryApiCallQuery,
} from "@/services/api/transactions/transactions.api";

const Tabs = [
  {
    id: 0,
    label: "Referred Users",
  },
  {
    id: 1,
    label: "Assigned Codes",
  },
  {
    id: 2,
    label: "Reward History",
  },
];

export const Refferal = () => {
  const [domain] = useState(window.location.origin);
  const [activeTab, setActiveTab] = useState("Referred Users");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageUserReferral, setCurrentPageUserReferral] = useState(1);
  const [currentPageReward, setCurrentPageReward] = useState(1);

  const [copiedReferral, setCopiedReferral] = useState(false);
  const [currentIndex, setcurrentIndex] = useState<number | null>(null);

  const limit = 10;

  const {
    data: refferalData,
    isLoading,
    isError,
  } = useGetRefferalsApiCallQuery({
    page: currentPage,
    limit,
  });

  const {
    data: refferalUsersData,
    isLoading: isLoadinRefferalUsers,
    isError: isErrorRefferalUsers,
  } = useGetRefferalUsersApiCallQuery({
    page: currentPageUserReferral,
    limit: 10,
  });

  const {
    data: rewardData,
    isLoading: isLoadingReward,
    isError: isErrorReward,
  } = useGetTransactionsApiCallQuery({
    transactionType: "REWARD",
  });

  const totalPages = refferalData?.result?.pages || 1;
  const totalPagesUserReferral = refferalUsersData?.result?.pages || 1;
  const totalPagesReward = refferalData?.result?.pages || 1;

  const handlePrev = () => setCurrentPage((p) => Math.max(p - 1, 1));
  const handleNext = () => setCurrentPage((p) => Math.min(p + 1, totalPages));

  const handlePrevUserReferral = () =>
    setCurrentPageUserReferral((p) => Math.max(p - 1, 1));
  const handleNextUserReferral = () =>
    setCurrentPageUserReferral((p) => Math.min(p + 1, totalPagesUserReferral));

  const handlePrevReward = () =>
    setCurrentPageReward((p) => Math.max(p - 1, 1));
  const handleNextReward = () =>
    setCurrentPageReward((p) => Math.min(p + 1, totalPages));

  const handleCopyReferral = (referralLink: string, index: number) => {
    setcurrentIndex(index);
    navigator.clipboard.writeText(referralLink);
    setCopiedReferral(true);
    setTimeout(() => setcurrentIndex(null), 2000);
  };

  const { data: tokenPriceData } = useGetTokenPriceConversionApiCallQuery();

  const getUSDTBalance = (walletBalance: number) => {
    const usdtPrice =
      tokenPriceData?.result?.data?.find((item: any) => item.coin === "usdt")
        ?.tokenPrice || 0;
    const balance = walletBalance * usdtPrice || 0;
    return balance;
  };

  return (
    <div className="max-w-7xl mx-auto p-4 space-y-4">
      {/* <h2 className="text-lg font-semibold">Activity Logs</h2> */}

      <div
        className="flex items-center justify-between gap-8 mt-8 bg-gray-800 rounded-md px-2 py-1"
        id="campaigns"
      >
        {Tabs.map((tab, index) => {
          const isActiveTab = activeTab === tab.label;
          return (
            <div
              key={tab.id}
              className={`w-full rounded-full flex items-center justify-center gap-2 cursor-pointer py-1 font-medium ${
                isActiveTab ? "text-gray-700 bg-yellow-500" : "text-white"
              }`}
              onClick={() => setActiveTab(tab.label)}
            >
              <p>{tab.label}</p>
            </div>
          );
        })}
      </div>

      {activeTab === "Referred Users" && (
        <div>
          <div>
            <div className="border rounded-md overflow-hidden">
              <Table>
                <TableHeader className="bg-gray-100 dark:bg-gray-800">
                  <TableRow>
                    <TableHead>Wallet Address</TableHead>
                    <TableHead>Total Claimed</TableHead>
                    <TableHead>USDT Balance</TableHead>

                    <TableHead>Date</TableHead>
                    {/* <TableHead>Status</TableHead> */}
                    {/* <TableHead>User ID</TableHead> */}
                    {/* <TableHead className="text-right">Actions</TableHead> */}
                  </TableRow>
                </TableHeader>

                <TableBody>
                  {isLoading ? (
                    <TableRow>
                      <TableCell colSpan={6} className="text-center h-24">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : isError ? (
                    <TableRow>
                      <TableCell colSpan={6} className="text-center h-24">
                        No Refferal Found
                      </TableCell>
                    </TableRow>
                  ) : refferalData?.result?.docs &&
                    refferalData?.result?.docs?.length > 0 ? (
                    refferalData.result.docs.map((ref, idx) => (
                      <TableRow
                        key={ref._id}
                        className={
                          idx % 2 === 0
                            ? "bg-white dark:bg-gray-900"
                            : "bg-gray-50 dark:bg-gray-800"
                        }
                      >
                        <TableCell className="max-w-xs truncate">
                          {ref.walletAddress}
                        </TableCell>
                        <TableCell>{ref.totalClaimed}</TableCell>
                        <TableCell>
                          ${Number(getUSDTBalance(ref.totalClaimed)).toFixed(2)}{" "}
                        </TableCell>

                        {/* <TableCell>{log.status}</TableCell> */}
                        <TableCell>
                          {new Date(ref.createdAt).toLocaleDateString("en-US", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          })}
                        </TableCell>
                        {/* <TableCell className="truncate">{log.userId}</TableCell> */}
                        {/* <TableCell className="text-right">
                    <Button size="icon" variant="ghost">
                      <Eye className="h-4 w-4" />
                    </Button>
                  </TableCell> */}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} className="text-center h-24">
                        No Referral Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>

            {totalPages > 1 && (
              <div className="flex justify-between items-center pt-4 border-t border-gray-200 dark:border-gray-700 mt-4">
                <div className="flex items-center gap-2">
                  <Button
                    onClick={handlePrev}
                    disabled={currentPage === 1}
                    variant="secondary"
                    size="sm"
                    className="bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700"
                  >
                    <ChevronLeft className="h-4 w-4 mr-1" /> Prev
                  </Button>

                  <Button
                    onClick={handleNext}
                    disabled={currentPage === totalPages}
                    variant="secondary"
                    size="sm"
                    className="bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700"
                  >
                    Next <ChevronRight className="h-4 w-4 ml-1" />
                  </Button>
                </div>

                <span className="text-sm text-gray-600 dark:text-gray-300">
                  Page <span className="font-medium">{currentPage}</span> of{" "}
                  <span className="font-medium">{totalPages}</span>
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {activeTab === "Assigned Codes" && (
        <div>
          <div>
            <div className="border rounded-md overflow-hidden">
              <Table>
                <TableHeader className="bg-gray-100 dark:bg-gray-800">
                  <TableRow>
                    <TableHead>Code</TableHead>
                    <TableHead>Amount</TableHead>
                    <TableHead>USDT Balance</TableHead>
                    {/* <TableHead>User ID</TableHead> */}
                    {/* <TableHead className="text-right">Actions</TableHead> */}
                  </TableRow>
                </TableHeader>

                <TableBody>
                  {isLoadinRefferalUsers ? (
                    <TableRow>
                      <TableCell colSpan={2} className="text-center h-24">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : isErrorRefferalUsers ? (
                    <TableRow>
                      <TableCell colSpan={2} className="text-center h-24">
                        No Assigned Code Found
                      </TableCell>
                    </TableRow>
                  ) : refferalUsersData?.result?.docs &&
                    refferalUsersData?.result?.docs?.length > 0 ? (
                    refferalUsersData.result.docs.map((ref, idx) => (
                      <TableRow
                        key={ref._id}
                        className={
                          idx % 2 === 0
                            ? "bg-white dark:bg-gray-900"
                            : "bg-gray-50 dark:bg-gray-800"
                        }
                      >
                        <TableCell>
                          <div className="flex items-center gap-2">
                            <span className="font-mono text-sm">{`${domain}/ref/${ref.code}`}</span>

                            <Button
                              size="sm"
                              onClick={() =>
                                handleCopyReferral(
                                  `${domain}/ref/${ref.code}`,
                                  idx
                                )
                              }
                              className={`cursor-pointer text-xs  flex items-center gap-1 ${
                                currentIndex === idx
                                  ? "bg-green-500/20 text-black border border-green-500/30"
                                  : "bg-primary hover:bg-primary/90 text-primary-foreground"
                              }`}
                            >
                              <Copy size={8} />{" "}
                              {idx === currentIndex && <div>Copied</div>}
                            </Button>
                          </div>
                        </TableCell>
                        <TableCell>{ref.amount}</TableCell>
                        <TableCell>
                          ${Number(getUSDTBalance(ref.amount)).toFixed(2)}{" "}
                        </TableCell>
                        {/* <TableCell>{log.status}</TableCell> */}
                        {/* <TableCell>
                          {new Date(ref.createdAt).toLocaleDateString("en-US", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          })}
                        </TableCell> */}
                        {/* <TableCell className="truncate">{log.userId}</TableCell> */}
                        {/* <TableCell className="text-right">
                    <Button size="icon" variant="ghost">
                      <Eye className="h-4 w-4" />
                    </Button>
                  </TableCell> */}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} className="text-center h-24">
                        No Referral Found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>

            {totalPagesUserReferral > 1 && (
              <div className="flex justify-between items-center pt-4 border-t border-gray-200 dark:border-gray-700 mt-4">
                <div className="flex items-center gap-2">
                  <Button
                    onClick={handlePrevUserReferral}
                    disabled={currentPageUserReferral === 1}
                    variant="secondary"
                    size="sm"
                    className="bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700"
                  >
                    <ChevronLeft className="h-4 w-4 mr-1" /> Prev
                  </Button>

                  <Button
                    onClick={handleNextUserReferral}
                    disabled={
                      currentPageUserReferral === totalPagesUserReferral
                    }
                    variant="secondary"
                    size="sm"
                    className="bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700"
                  >
                    Next <ChevronRight className="h-4 w-4 ml-1" />
                  </Button>
                </div>

                <span className="text-sm text-gray-600 dark:text-gray-300">
                  Page{" "}
                  <span className="font-medium">{currentPageUserReferral}</span>{" "}
                  of{" "}
                  <span className="font-medium">{totalPagesUserReferral}</span>
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {activeTab === "Reward History" && (
        <div>
          <div>
            <div className="border rounded-md overflow-hidden">
              <Table>
                <TableHeader className="bg-gray-100 dark:bg-gray-800">
                  <TableRow>
                    <TableHead>Campaign Name</TableHead>
                    <TableHead>Amount</TableHead>
                    <TableHead>USDT Balance</TableHead>

                    <TableHead>From</TableHead>
                    {/* <TableHead>Status</TableHead> */}
                    {/* <TableHead>User ID</TableHead> */}
                    {/* <TableHead className="text-right">Actions</TableHead> */}
                  </TableRow>
                </TableHeader>

                <TableBody>
                  {isLoadingReward ? (
                    <TableRow>
                      <TableCell colSpan={3} className="text-center h-24">
                        Loading...
                      </TableCell>
                    </TableRow>
                  ) : isErrorReward ? (
                    <TableRow>
                      <TableCell colSpan={3} className="text-center h-24">
                        No Reward Found
                      </TableCell>
                    </TableRow>
                  ) : rewardData?.result?.docs &&
                    rewardData?.result?.docs?.length > 0 ? (
                    rewardData.result.docs.map((ref, idx) => (
                      <TableRow
                        key={ref._id}
                        className={
                          idx % 2 === 0
                            ? "bg-white dark:bg-gray-900"
                            : "bg-gray-50 dark:bg-gray-800"
                        }
                      >
                        <TableCell>{ref.campaignId.name}</TableCell>
                        <TableCell>{ref.amount}</TableCell>
                        <TableCell>
                          ${Number(getUSDTBalance(ref.amount)).toFixed(2)}{" "}
                        </TableCell>
                        <TableCell>{ref.from}</TableCell>

                        {/* <TableCell>{log.status}</TableCell> */}
                        {/* <TableCell>
                          {new Date(ref.createdAt).toLocaleDateString("en-US", {
                            day: "numeric",
                            month: "short",
                            year: "numeric",
                          })}
                        </TableCell> */}
                        {/* <TableCell className="truncate">{log.userId}</TableCell> */}
                        {/* <TableCell className="text-right">
                    <Button size="icon" variant="ghost">
                      <Eye className="h-4 w-4" />
                    </Button>
                  </TableCell> */}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={6} className="text-center h-24">
                        No Reward History
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </div>

            {totalPagesReward > 1 && (
              <div className="flex justify-between items-center pt-4 border-t border-gray-200 dark:border-gray-700 mt-4">
                <div className="flex items-center gap-2">
                  <Button
                    onClick={handlePrevReward}
                    disabled={currentPageReward === 1}
                    variant="secondary"
                    size="sm"
                    className="bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700"
                  >
                    <ChevronLeft className="h-4 w-4 mr-1" /> Prev
                  </Button>

                  <Button
                    onClick={handleNextReward}
                    disabled={currentPageReward === totalPagesReward}
                    variant="secondary"
                    size="sm"
                    className="bg-gray-100 dark:bg-gray-800 hover:bg-gray-200 dark:hover:bg-gray-700"
                  >
                    Next <ChevronRight className="h-4 w-4 ml-1" />
                  </Button>
                </div>

                <span className="text-sm text-gray-600 dark:text-gray-300">
                  Page <span className="font-medium">{currentPageReward}</span>{" "}
                  of <span className="font-medium">{totalPagesReward}</span>
                </span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
